import { EVENT_TYPES } from "@/lib/eventTypes";

// Multi-choice chips for event categories (alerts). Nothing ticked = every kind of event.
export const TypeChips = ({ value, onChange, dark = false, testId = "type-chips" }) => {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  const off = dark ? "border-black/40 text-black hover:border-black" : "border-white/40 text-white hover:border-white";
  const on = dark ? "bg-black text-white border-black" : "bg-white text-black border-white";
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {EVENT_TYPES.map((t) => (
        <button key={t.key} type="button" onClick={() => toggle(t.key)} aria-pressed={value.includes(t.key)} data-testid={`${testId}-${t.key}`}
          className={`h-9 px-3 border text-[11px] uppercase tracking-[0.15em] font-bold transition-colors duration-200 ${value.includes(t.key) ? on : off}`}>
          {t.plural}
        </button>
      ))}
    </div>
  );
};
